import React from "react";
import "./policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <h1>Privacy Policy</h1>
      <p>
        At <strong>Around the Globe</strong>, your privacy is our top priority.
        This Privacy Policy explains how we collect, use, and safeguard your
        personal information when you use our website and services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal details such as your name, email address,
        contact number, and travel preferences to provide seamless services.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information to process bookings, provide customer support,
        send updates, and improve user experience.
      </p>

      <h2>3. Data Safety</h2>
      <p>
        We implement strong safety protocols to ensure your information stays
        secure and confidential.
      </p>

      <h2>4. Contact Us</h2>
      <p>
        If you have any questions regarding our privacy practices, feel free to
        reach us anytime.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
